import React, { useState, useRef, useEffect } from 'react';
import { useAppearance } from '../../contexts/AppearanceProvider';
import { BaseComponentProps } from '../../types';
import HeaderMobile from './HeaderMobile';
import HeaderDesktop from './HeaderDesktop';
import { useHeaderTranslation } from '../../modules/i18n';

interface HeaderProps extends BaseComponentProps {
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ title, className = '' }) => {
  const { t } = useHeaderTranslation();
  const { isDarkMode, toggleDarkMode } = useAppearance();
  const [isMobile, setIsMobile] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [hoveredSubmenu, setHoveredSubmenu] = useState<string | null>(null);
  const settingsRef = useRef<HTMLDivElement>(null);

  // Kiểm tra mobile/desktop
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Đóng dropdown khi click bên ngoài
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (settingsRef.current && !settingsRef.current.contains(event.target as Node)) {
        setIsSettingsOpen(false);
        setHoveredSubmenu(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Shared props cho cả mobile và desktop
  const sharedProps = {
    title: title || t('title'),
    className,
    isDarkMode,
    toggleDarkMode,
    isSettingsOpen,
    setIsSettingsOpen,
    settingsRef,
    hoveredSubmenu,
    setHoveredSubmenu
  };

  // Render appropriate header based on screen size
  return isMobile ? <HeaderMobile {...sharedProps} /> : <HeaderDesktop {...sharedProps} />;
};

export default Header;
